import React from "react";

import HeroTop from "../../components/marketing/heroTop/HeroTop";
import ProductsCategory from "../../components/marketing/pageSections/home/ProductsCategory";
import CallToAction from "../../components/marketing/pageSections/home/CallToAction";
import Products from "../../components/marketing/pageSections/home/Products";
import FilterProducts from "../../components/marketing/pageSections/home/FilterProducts";

const BodyHome = () => {
  return (
    <>
      <HeroTop />
      <ProductsCategory />
      <CallToAction />
      <Products />
      <FilterProducts />
    </>
  );
};

export default BodyHome;
